/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Salary_Negotiate_Other_TitleInputs */

const en_salary_negotiate_other_title = /** @type {(inputs: Salary_Negotiate_Other_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beyond Salary: What Else to Negotiate`)
};

const de_salary_negotiate_other_title = /** @type {(inputs: Salary_Negotiate_Other_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Über das Gehalt hinaus: Was du noch verhandeln kannst`)
};

const fr_salary_negotiate_other_title = /** @type {(inputs: Salary_Negotiate_Other_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Au-delà du salaire : quoi d'autre négocier`)
};

const es_salary_negotiate_other_title = /** @type {(inputs: Salary_Negotiate_Other_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Más allá del salario: qué más negociar`)
};

const it_salary_negotiate_other_title = /** @type {(inputs: Salary_Negotiate_Other_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oltre lo stipendio: cos'altro negoziare`)
};

const nl_salary_negotiate_other_title = /** @type {(inputs: Salary_Negotiate_Other_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naast salaris: wat kun je nog meer onderhandelen`)
};

const pl_salary_negotiate_other_title = /** @type {(inputs: Salary_Negotiate_Other_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poza wynagrodzeniem: co jeszcze negocjować`)
};

const fi_salary_negotiate_other_title = /** @type {(inputs: Salary_Negotiate_Other_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Palkan lisäksi: mitä muuta neuvotella`)
};

const da_salary_negotiate_other_title = /** @type {(inputs: Salary_Negotiate_Other_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ud over løn: hvad ellers at forhandle`)
};

const sv_salary_negotiate_other_title = /** @type {(inputs: Salary_Negotiate_Other_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utöver lönen: vad mer att förhandla`)
};

/**
* | output |
* | --- |
* | "Beyond Salary: What Else to Negotiate" |
*
* @param {Salary_Negotiate_Other_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const salary_negotiate_other_title = /** @type {((inputs?: Salary_Negotiate_Other_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Salary_Negotiate_Other_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_salary_negotiate_other_title(inputs)
	if (locale === "fr") return fr_salary_negotiate_other_title(inputs)
	if (locale === "es") return es_salary_negotiate_other_title(inputs)
	if (locale === "it") return it_salary_negotiate_other_title(inputs)
	if (locale === "nl") return nl_salary_negotiate_other_title(inputs)
	if (locale === "pl") return pl_salary_negotiate_other_title(inputs)
	if (locale === "fi") return fi_salary_negotiate_other_title(inputs)
	if (locale === "da") return da_salary_negotiate_other_title(inputs)
	if (locale === "sv") return sv_salary_negotiate_other_title(inputs)
	return en_salary_negotiate_other_title(inputs)
});